/*
 * Vue 3 port of the subset of @coreui/vue v3 used by this panel. It renders exactly the same
 * markup/classes as CoreUI v3, so the existing @coreui/coreui v3 SCSS (RTL, theme) keeps working.
 * Register with app.use(CoreuiVue3, { icons }).
 */
import * as basic from './basic'
import { CLink } from './link'
import CIcon from './CIcon.vue'
import CFormGroup from './form/CFormGroup.vue'
import CInput from './form/CInput.vue'
import CTextarea from './form/CTextarea.vue'
import CSelect from './form/CSelect.vue'
import CInputCheckbox from './form/CInputCheckbox.vue'
import CInputRadio from './form/CInputRadio.vue'
import CInputFile from './form/CInputFile.vue'
import CSwitch from './CSwitch.vue'
import CModal from './CModal.vue'
import CAlert from './CAlert.vue'
import CImg from './CImg.vue'
import CPagination from './CPagination.vue'
import CDropdown from './CDropdown.vue'
import CDataTable from './CDataTable.vue'
import CElementCover from './CElementCover.vue'
import CScrollbar from './CScrollbar.vue'
import { CDropdownItem } from './CDropdownItem'
import { CProgress, CProgressBar } from './progress'
import { CTabs, CTab } from './tabs'
import { CSidebar, CSidebarNav, CSidebarNavItem, CSidebarNavDropdown, CRenderFunction } from './sidebar'
import CWidgetBrand from './widgets/CWidgetBrand.vue'
import CWidgetDropdown from './widgets/CWidgetDropdown.vue'
import CWidgetIcon from './widgets/CWidgetIcon.vue'
import CWidgetProgress from './widgets/CWidgetProgress.vue'
import CWidgetProgressIcon from './widgets/CWidgetProgressIcon.vue'
import CWidgetSimple from './widgets/CWidgetSimple.vue'
import * as charts from './charts'
import { CClickaway } from './directives'
import { setIcons } from './icons'

export const components = {
  ...basic,
  CLink,
  CIcon,
  CFormGroup,
  CInput,
  CTextarea,
  CSelect,
  CInputCheckbox,
  CInputRadio,
  CInputFile,
  CSwitch,
  CModal,
  CAlert,
  CImg,
  CPagination,
  CDropdown,
  CDropdownItem,
  CDataTable,
  CElementCover,
  CScrollbar,
  CProgress,
  CProgressBar,
  CTabs,
  CTab,
  CSidebar,
  CSidebarNav,
  CSidebarNavItem,
  CSidebarNavDropdown,
  CRenderFunction,
  CWidgetBrand,
  CWidgetDropdown,
  CWidgetIcon,
  CWidgetProgress,
  CWidgetProgressIcon,
  CWidgetSimple,
  ...charts
}
delete components.convertOptions

export {
  CLink, CIcon, CFormGroup, CInput, CTextarea, CSelect, CInputCheckbox, CInputRadio, CInputFile, CSwitch,
  CModal, CAlert, CImg, CPagination, CDropdown, CDropdownItem, CDataTable, CElementCover, CScrollbar,
  CProgress, CProgressBar, CTabs, CTab, CSidebar, CSidebarNav, CSidebarNavItem, CSidebarNavDropdown, CRenderFunction
}
export * from './basic'
export * from './charts'

export default {
  install (app, options = {}) {
    if (options.icons) setIcons(options.icons)
    Object.keys(components).forEach((name) => app.component(name, components[name]))
    app.directive('c-clickaway', CClickaway)
  }
}
